/**
 * 登录提示框组件
 */
define(['raw!./loginBox.html'], (tmpl) => {
  var widget = avalon.ui.loginBox = (element, data, vmodels) => {
    var options = data.loginBoxOptions;
    var vmodel = avalon.define(data.loginBoxId, (vm) => {
      avalon.mix(vm, options);

      vm.$skipArray = [];

      vm.$init = () => {
        element.innerHTML = tmpl;

        avalon.nextTick(() => {
          avalon.scan(element, [vmodel].concat(vmodels));
          vmodel.onInit(element, vmodel);
        });
      };

      vm.show = () => {
        vmodel.visible = true;
      };

      vm.hide = () => {
        vmodel.visible = false;
      };

      vm.close = () => {
        vmodel.onClose();
      };

      vm.login = () => {
        vmodel.onLogin();
      };

      //移除插件
      vm.$remove = () => {
        element.innerHTML = '';
      };
    });

    return vmodel;
  };

  widget.defaults = {
    visible: false,
    onInit: avalon.noop,
    onClose: avalon.noop,
    onLogin: avalon.noop
  }

  return avalon;
});



/** WEBPACK FOOTER **
 ** ./src/modules/unipay/scripts/widgets/loginBox.js
 **/